import { render, staticRenderFns } from "./FactsheetCollection.vue?vue&type=template&id=347bdd66&scoped=true"
import script from "./FactsheetCollection.vue?vue&type=script&lang=js"
export * from "./FactsheetCollection.vue?vue&type=script&lang=js"
import style1 from "./FactsheetCollection.vue?vue&type=style&index=1&id=347bdd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347bdd66",
  null
  
)

export default component.exports